module.exports = __webpack_public_path__ + "img/h5img46.024f2036.png";